import { render, staticRenderFns } from "./ClassSearchSlidebar.vue?vue&type=template&id=7b17b68e"
import script from "./ClassSearchSlidebar.vue?vue&type=script&lang=js"
export * from "./ClassSearchSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports